import angular from 'angular';
import './utils';

const memoryLeaksDiagnosticsModule = angular.module('memory-leaks-diagnostics', []);
export default memoryLeaksDiagnosticsModule.name;

memoryLeaksDiagnosticsModule.config(($stateProvider) => {
  'ngInject';

  $stateProvider.state('fake-empty-state', {
    url: '/fake-empty-state',
    template: `
      <div style="height: 100vh; position: relative; text-align: center;">
        <div style="position: absolute; transform: translate(-50%, -50%); left: 50%; top: 50%">
          <h1 style="font-size: 250%; margin-bottom: 50px">Memory leaks diagnostics page</h1>
          <h3>
            <p>This view is a top level state that is essentially empty i.e. no controller, no directives, no components.</p>
            <p>It is used by memory leaks diagnostics as a reference state to compare memory usage.</p>
            <p>If you don't know what the hell is all that you probably want to <span style="color: magenta; white-space: nowrap">disable the <code>INCLUDE_MEMORY_LEAKS_DIAGNOSTICS</code> flag in config</span></p>
          <h3>
        </div>
      </div>
    `,
    data: {
      title: '🛠🔬 Empty 🚰☔️',
    },
  });
});

memoryLeaksDiagnosticsModule.component('memoryLeaksDiagnosticsMenuItem', {
  template: `
    <a ui-sref="fake-empty-state" ng-class="{active: ctrl.isActive('fake-empty-state')}">
      <span>🛠🔬 Empty 🚰☔️</span>
    </a>
  `,
  controllerAs: 'ctrl',
  controller($state) {
    'ngInject';

    this.isActive = function isActive(sref) {
      return $state.includes(sref);
    };
  },
});
